<template>
    <div>
        <b-loading :active.sync="isLoading" :is-full-page="true"></b-loading>

        <div>
          <div class="title">Step 1: pick a pack</div>

          <b-autocomplete
              v-model="packSelect"
              :data="packs"
              :keep-first="true"
              :loading="isLoading"
              :open-on-focus="true"
              clearable
              field="name"
              placeholder="e.g. Sports"
              size="is-large"
              @select="option => packSelected(option)">

            <template slot-scope="props">
              <div class="media">
                <div class="media-content">
                  <b>{{ props.option.name }} -
                    {{ props.option.rawActivityIds ? props.option.rawActivityIds.length : 0 }}
                    activities</b>
                  <br>
                  <small>{{ props.option.description }}</small>
                  <br>
                  <b-taglist>
                    <b-tag
                        v-for="(age, index) in props.option.suitableFor"
                        :key="index"
                        type="is-warning">{{ age }}
                    </b-tag>
                  </b-taglist>
                </div>
              </div>
            </template>
          </b-autocomplete>
        </div>

        <div v-if="step2">
            <div class="title">Step 2: select maps</div>
            <b-field v-for="(option, index) in maps">
                <b-checkbox
                        :key="index"
                        v-model="checkboxMaps"
                        :native-value="option.mapId"
                        @input="mapSelected">
                    {{ option.name }} ({{ option.geolocationPoints.length }} points)
                </b-checkbox>
            </b-field>
        </div>
        <div v-if="step3">
            <div class="title">Step 3: choose options</div>
            <b-field label="Public/Private games" label-position="on-border">
                <b-select v-model="gameTypeSelect" size="is-large">
                    <option value="public">Public</option>
                    <option value="private">Private</option>
                </b-select>
            </b-field>

            <b-field label="Intro" label-position="on-border">
                <b-select v-model="introSelect" size="is-large">
                    <option
                            v-for="option in introTexts"
                            :key="option.introTextId"
                            :value="option.introTextId">
                        {{ option.name }} ({{ option.cards ? option.cards.length : '?' }} cards)
                    </option>
                </b-select>
            </b-field>

            <b-field>
                <b-button class="btn-margin" icon-left="check" type="is-success" @click="goCreate">Create {{
                    checkboxMaps.length
                    }} games
                </b-button>
            </b-field>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import displayHelper from '../../helpers/display-helper'
    import packService from '@/services/packService'
    import mapService from '@/services/mapService'
    import {DialogProgrammatic as Dialog} from 'buefy'
    import moment from 'moment'
    import dateUtils from '@/helpers/date-helper'
    import rawActivityService from '@/services/rawActivityService'
    import gamesService from '@/services/gamesService'
    import introTextService from '@/services/introTextsService'

    export default {
      name: 'games-with-packs-en-masse',
      created() {
        this.loadPacksList()
                .then(() => {
                  this.packs = _.filter(this.packs, pack => {
                    return !!pack.rawActivityIds
                  })
                })
      },
      data() {
        return {
          isLoading: false,
          packs: [],
          maps: [],
          introTexts: [],
          rawActivities: [],
          step2: false,
          step3: false,
          checkboxMaps: [],
          packSelect: '',
          gameTypeSelect: '',
          introSelect: '',

          thePack: null,
        }
      },
      methods: {
        loadPacksList() {
          this.isLoading = true
          const parent = this
          return packService.getPacks()
                    .then((packs) => {
                      this.packs = packs
                    })
                    .catch((err) => {
                      displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
        },
        loadMapsList() {
          this.isLoading = true
          const parent = this
          return mapService.getFullMaps()
                    .then((maps) => {
                      this.maps = maps
                    })
                    .catch((err) => {
                      displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
        },
        loadRawActivitiesList() {
          this.isLoading = true
          const parent = this
          return rawActivityService.getRawActivities()
                    .then((rawActivities) => {
                      this.rawActivities = rawActivities
                    })
                    .catch((err) => {
                      displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
        },
        loadIntroTextsList() {
          const parent = this
          return introTextService.getIntroTexts()
                    .then((introTexts) => {
                      console.log(introTexts[0])
                      this.introTexts = introTexts
                    })
              .catch((err) => {
                displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
              })
              .finally(() => {
                this.isLoading = false
              })
        },
        packSelected(option) {
          if (!option) {
            this.step2 = false
            return
          }
          this.thePack = _.find(this.packs, ['packId', option.packId])

          this.loadMapsList()
              .then(() => {
                this.maps = _.filter(this.maps, map => {
                  return (this.thePack.rawActivityIds.length >= map.geolocationPoints.length)
                })

                this.step2 = true
              })
        },
        mapSelected() {
          this.loadIntroTextsList()
                    .then(() => {
                      this.step3 = true
                    })
        },
        goCreate() {
          Dialog.confirm({
            message: 'Are you sure you want to create these games?',
            onConfirm: () => this.createGamesEnMasse()
          })
        },
        createGamesEnMasse() {
          const parent = this

          const gameSkeleton = {
            accessType: this.gameTypeSelect,
            gameDescription: 'created by 1PackNMaps',
            image: null,
            gameLogo: null,
            gameStatus: 'new',
            gameStyle: 'Classic',
            isAlwaysOn: 'true',
            gameOverMode: '',
            isLeaderDisabled: 'false',
            isShowOtherTeamsEnabled: 'true',
            playWithTeams: 'true',
            playerCanAddTeams: 'false',
            questionRadius: '30',
            creationMode: 'Wizard',
          }

          const mapsToClone = _.filter(this.maps, map => {
            return this.checkboxMaps.includes(map.mapId)
          })

          console.log(this.thePack)

          const now = dateUtils.mergeTimeToDate(new Date(), new Date())

          this.loadRawActivitiesList()
                    .then(() => {
                      this.rawActivities = _.filter(this.rawActivities, activity => {
                        return this.thePack.rawActivityIds.includes(activity.rawActivityId)
                      })

                      const promises = _.map(mapsToClone, map => {
                        let gameToCreate = _.cloneDeep(gameSkeleton)

                        _.set(gameToCreate, 'map.mapName', map.name)
                        _.set(gameToCreate, 'map.id', map.mapId)

                        let markers = map.geolocationPoints.map(obj => {
                          return {position: {lng: Number(obj.lng), lat: Number(obj.lat)}}
                        })

                        _.set(gameToCreate, 'map.markers', markers)

                        _.set(gameToCreate, 'chosenPack.packId', this.packSelect)
                        _.set(gameToCreate, 'chosenPack.packName', this.thePack.name)

                        _.set(gameToCreate, 'gameDisplayedName', map.name)
                        _.set(gameToCreate, 'gameName', map.name)

                        _.set(gameToCreate, 'introTextId', this.introSelect)

                        _.set(gameToCreate, 'createdAt', now)
                        _.set(gameToCreate, 'gameEndDate', now)
                        _.set(gameToCreate, 'gameEndRawDate', now)
                        _.set(gameToCreate, 'gameStartDate', now)
                        _.set(gameToCreate, 'gameStartRawDate', now)

                        let activities = _.take(_.shuffle(this.rawActivities), map.geolocationPoints.length)

                        let associationMarkersActivities = []
                        let avg = [map.geolocationPoints[0].lat, map.geolocationPoints[0].lng]

                        for (let i = 0; i < map.geolocationPoints.length; i++) {
                          associationMarkersActivities.push(
                            {
                              rawActivityId: activities[i].rawActivityId,
                              position: {
                                lat: map.geolocationPoints[i].lat,
                                lng: map.geolocationPoints[i].lng,
                              },

                              imgSrc: activities[i].imgSrc,
                              name: activities[i].name,
                              content: {
                                question: activities[i].content.question,
                                unlocked_forced: activities[i].content.unlocked_forced
                              },
                              activityType: activities[i].activityType,
                              timeToAnswer: activities[i].timeToAnswer,
                            }
                                )
                        }

                        _.set(gameToCreate, 'initialGeolocation.lat', avg[0])
                        _.set(gameToCreate, 'initialGeolocation.lng', avg[1])
                        _.set(gameToCreate, 'initialGeolocation.zoom', 15)

                        _.set(gameToCreate, 'associationMarkersActivities', associationMarkersActivities)

                        console.log(gameToCreate)

                        this.isLoading = true

                        return gamesService.createGameWithWizard(gameToCreate)
                      })
                      Promise.all(promises)
                         .then(() => {
                           displayHelper.displaySuccess(parent, 'The games have been created with success')
                           this.$router.push({name: 'Games'})
                         })
                         .catch((err) => {
                           displayHelper.displayError(parent, 'Oops, there was an error while creating the games: ' + err.message)
                         })
                         .finally(() => {
                           this.isLoading = false
                         })
                    })
        },
        formatDateAndTime(d) {
          return moment(d).format('DD/MM/YYYY HH:mm').toString()
        },
      }
    }
</script>

<style scoped>
    .title {
        margin-top: 20px;
    }
</style>
